const issuers = {
  FTRPRF: 'FTRPRF',
  SMARTSCHOOL: 'SMARTSCHOOL',
  TEAMS: 'TEAMS',
};

export default issuers;
